import { Box, Slider } from '@mui/material';
import { func, object, string } from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import messages from 'store/app/entities/messages/action';
import useConnecting from 'utils/useConnecting';
import useSendAction from 'utils/useSendAction';

const BlockSlider = ({ slider, msgId, blockId, updateMessage }) => {
  const [value, setValue] = useState(
    slider.value || Math.round((slider.maxValue - slider.minValue) / 2),
  );
  const onResponseOk = msg => {
    updateMessage(msg);
  };

  const [disabled, send] = useSendAction(slider, msgId, blockId, onResponseOk);
  const connecting = useConnecting();

  const onValueChange = (event, val) => {
    setValue(val);
  };

  const onSlidingComplete = async (event, val) => {
    await send(val);
  };

  const marks = [];
  if (slider.showSteps && slider.step) {
    for (let i = slider.minValue; i <= slider.maxValue; i += slider.step) {
      marks.push({ value: i, label: `${i}` });
    }
  }

  return (
    <Box
      key={`button-${slider.actionId}`}
      sx={theme => ({
        flex: 1,
        justifyContent: 'center',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(4),
      })}
    >
      <Slider
        marks={marks}
        color="primary"
        step={slider.step}
        value={value}
        onChange={onValueChange}
        onChangeCommitted={onSlidingComplete}
        disabled={connecting || disabled || slider.disabled}
        sx={theme => ({
          width: '100%',
          padding: 0,
          '& .MuiSlider-markLabel': {
            top: theme.spacing(2),
          },
        })}
        min={slider.minValue}
        max={slider.maxValue}
      />
    </Box>
  );
};

BlockSlider.propTypes = {
  slider: object.isRequired,
  msgId: string.isRequired,
  blockId: string.isRequired,
  updateMessage: func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  updateMessage: messages.updateSuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlockSlider);
